import { useCart as useCartContext } from '../../context/CartContext';

export const useCart = useCartContext;

export default useCart;
